import axios from 'axios'

export default {
    namespaced: true,
    state: {
        spaSalons: []
    },
    mutations: {
        FETCH_SPA(state, spa) {
            state.spaSalons = spa
        },
        ADD_SPA(state, spa) {
            state.spaSalons.push(spa)
        },
        EDIT_SPA(state, spa) {
            const index = state.spaSalons.findIndex(
                item => item.id === spa.id
            )
            if (index !== -1) {
                Object.assign(state.spaSalons[index], spa)
            }
        },
        DEL_SPA(state, spa) {
            const index = state.spaSalons.findIndex(
                item => item.id === spa.id
            )
            if (index !== -1) {
                state.spaSalons.splice(index, 1)
            }
        }
    },
    actions: {
        fetch({commit, dispatch, state}, isPreload = true) {
            if (!state.spaSalons.length) {
                if (isPreload) {
                    commit('TOGGLE_PRELOADER', true, {root: true})
                }
                return axios.get(
                    '/api/root/spa-salons/list'
                ).then(({data}) => {
                    commit('FETCH_SPA', data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                }).finally(() => {
                    if (isPreload) {
                        commit('TOGGLE_PRELOADER', false, {root: true})
                    }
                })
            }
        },
        add({commit, dispatch}, data) {
            return new Promise((resolve) => {
                axios.post(
                    '/api/root/spa-salons/add',
                    prepareData(data)
                ).then(({data}) => {
                    commit('ADD_SPA', data.data)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                })
            })
        },
        edit({commit, dispatch}, editedItem) {
            return new Promise((resolve) => {
                axios.post(
                    '/api/root/spa-salons/edit/' + editedItem.id,
                    prepareData(editedItem)
                ).then(({data}) => {
                    commit('EDIT_SPA', data.data)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        delete({commit, dispatch}, itemId) {
            return new Promise((resolve) => {
                axios.delete(
                    '/api/root/spa-salons/dell/' + itemId
                ).then(({data}) => {
                    commit('DEL_SPA', data.data)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
    }
}

function prepareData (data) {
    const fd = new FormData()
    if (data.image) {
        fd.append('image', data.image)
    }
    fd.append('name', data.name)
    fd.append('city', data.city)
    fd.append('street', data.street)

    return fd
}
